var BrowserCookies = require('js-cookie');
export function getCookie(key) {
    return BrowserCookies.get(key);
}
export function updateCookie(key, value, options) {
    if (value) {
        BrowserCookies.set(key, value, options);
    }
    else {
        BrowserCookies.remove(key);
    }
}
//# sourceMappingURL=browserCookieWrapper.js.map